import cornerstone from "cornerstone-core";
import { getTopconOptDisplayScaleX } from "../utils/topconOptDisplayStretch";

/** Horizontal scale to fill element width (cornerstone-core 2.x has no getImageFitScale). */
function computeHorizontalFitScale(element, image) {
  const elementWidth = element.clientWidth;
  if (elementWidth <= 0 || !image?.width) return null;

  const displayScaleX = getTopconOptDisplayScaleX(image);
  const effectiveWidth = image.width * displayScaleX;
  return elementWidth / effectiveWidth;
}

export const fitViewportToWidth = (element, image) => {
  if (!element || !image) return;

  const elementWidth = element.clientWidth;
  const elementHeight = element.clientHeight;

  if (elementWidth <= 0 || elementHeight <= 0) return;

  const horizontalScale = computeHorizontalFitScale(element, image);
  if (!horizontalScale || !Number.isFinite(horizontalScale)) return;

  const viewport = cornerstone.getDefaultViewportForImage(element, image);
  viewport.scale = horizontalScale;
  viewport.translation.x = 0;
  viewport.translation.y = 0;

  cornerstone.setViewport(element, viewport);
};

export const applyOptWidthFit = (element) => {
  if (!element) return;
  try {
    const image = cornerstone.getImage(element);
    fitViewportToWidth(element, image);
    cornerstone.updateImage(element);
  } catch (error) {
    // Image not ready yet
  }
};

/**
 * Display a stack frame while keeping the current width-fit viewport when possible.
 */
export const displayOptStackImage = (element, imageId, options = {}) => {
  const { preserveViewport = true } = options;
  if (!element || !imageId) return Promise.resolve();

  let savedViewport = null;
  if (preserveViewport) {
    try {
      savedViewport = cornerstone.getViewport(element);
    } catch (error) {
      savedViewport = null;
    }
  }

  return cornerstone
    .loadAndCacheImage(imageId)
    .then((image) => {
      cornerstone.displayImage(element, image);
      if (
        preserveViewport &&
        savedViewport &&
        Number.isFinite(savedViewport.scale)
      ) {
        cornerstone.setViewport(element, savedViewport);
      } else {
        fitViewportToWidth(element, image);
      }
      cornerstone.updateImage(element);
      return image;
    })
    .catch((error) => {
      console.error("OPT frame display failed:", error);
      throw error;
    });
};
